import React from 'react'
import DatePicker from 'react-16-bootstrap-date-picker'
import moment from 'moment'

export default class InvoiceDate extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(value) {
    let s = moment(value).format('YYYY-MM-DD') + "T" + moment().format('HH:mm:ss')
    this.props.handleDateChange(s)
  }

  render() {
      let inputValue
      if(typeof this.props.invoice !== "undefined" && typeof this.props.invoice.date !== "undefined") {
        inputValue = this.props.invoice.date
      }
      else {
        inputValue = moment().format()
      }

    return <DatePicker value={inputValue} onChange={this.handleChange} dateFormat="DD-MM-YYYY" showClearButton={false} />
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/invoicedate.js